import { createSelector } from '@reduxjs/toolkit';
import { getLastMessageId, getTradingMessages } from 'src/store/utils/bots';
import type { TradingState } from 'src/store/shared/tradingBots/types';

export interface Store {
  retainers: {
    bot: TradingState;
  };
}

const selectorTradingGroupList = (state: Store) => state.retainers.bot.groupList;
const selectorTradingSessionCreateStatus = (state: Store) =>
  state.retainers.bot.sessionCreateStatus;
export const selectorTradingSessionDetails = (state: Store) => state.retainers.bot.sessionDetails;
export const selectorTradingGroupListIsPending = (state: Store) =>
  state.retainers.bot.groupListStatus === 'pending';
export const selectorTradingMessageStatus = (state: Store) => state.retainers.bot.messageStatus;

export const selectorTradingGroupOptions = createSelector(selectorTradingGroupList, (groupList) =>
  (groupList ?? []).map(({ id, name }) => ({ value: String(id), label: name })),
);

export const selectorIsSessionActive = createSelector(
  selectorTradingSessionCreateStatus,
  selectorTradingSessionDetails,
  (status, sessionDetails) => status === 'success' && sessionDetails !== null,
);

export const selectorTradingMessageLog = (state: Store) => state.retainers.bot.messageLog;

export const selectorTradingMessages = createSelector(
  selectorTradingMessageLog,
  selectorTradingSessionDetails,
  getTradingMessages,
);

export const selectorTradingLastMessageId = createSelector(
  (state: Store) => state.retainers.bot.messageLog,
  getLastMessageId,
);
